import { useNavigate } from 'react-router-dom';

export function useRouting() {
  const navigate = useNavigate();

  const goToPage = (route: string, replace = false) => {
    navigate(route, { replace });
  };

  return {
    goToPage,
  };
}
